<ds-lib-login-form
  class="byd-login-form"
  [logos]="logos"
  [(language)]="language"
  [productName]="productName"
  (loggedIn)="loginSuccess()"
  (languageChange)="updateLanguage($event)"
>
</ds-lib-login-form>
